import { library } from '@fortawesome/fontawesome-svg-core';
import { faMoonAuto } from 'mangools-commons/dist/constants/Icons';

import {
    faArrowRight,
    faArrowUp,
    faBars,
    faCamera,
    faCaretDown,
    faCaretUp,
    faCheck,
    faChevronCircleLeft,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCloudUploadAlt,
    faCog,
    faComment,
    faCompress,
    faCopy,
    faDownload,
    faEdit,
    faEllipsisV,
    faExchangeAlt,
    faExclamation,
    faExclamationTriangle,
    faExpand,
    faExternalLinkAlt,
    faFont,
    faGift,
    faGlobeAmericas,
    faHistory,
    faImage,
    faInfoCircle,
    faKeyboard,
    faLanguage,
    faLaptop,
    faLevelUpAlt,
    faList,
    faLock,
    faMapMarkerAlt,
    faMinus,
    faMinusSquare,
    faMobileAlt,
    faMoon,
    faPaperPlane,
    faPencilAlt,
    faPercent,
    faPlug,
    faPlus,
    faPlusCircle,
    faPlusSquare,
    faPowerOff,
    faQuestion,
    faReply,
    faRocket,
    faSearch,
    faShareAlt,
    faSignOutAlt,
    faSort,
    faSortDown,
    faSortUp,
    faSpinner,
    faStar,
    faStream,
    faSun,
    faSync,
    faSyncAlt,
    faTimes,
    faUndoAlt,
    faUnlock,
    faUser,
    faUserCog,
    faWaveSquare,
} from '@fortawesome/free-solid-svg-icons';

import { faGoogle } from '@fortawesome/free-brands-svg-icons';

import {
    faClock,
    faClone,
    faCreditCard,
    faDotCircle,
    faEye,
    faEyeSlash,
    faFileExcel,
    faHandPaper,
    faLightbulb,
    faQuestionCircle,
    faTrashAlt,
} from '@fortawesome/free-regular-svg-icons';

library.add(
    faArrowRight,
    faArrowUp,
    faBars,
    faCamera,
    faCaretDown,
    faCaretUp,
    faCheck,
    faChevronCircleLeft,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faClock,
    faClone,
    faCloudUploadAlt,
    faCog,
    faComment,
    faCompress,
    faCopy,
    faCreditCard,
    faDotCircle,
    faDownload,
    faEdit,
    faEllipsisV,
    faExchangeAlt,
    faExclamation,
    faExclamationTriangle,
    faExpand,
    faExternalLinkAlt,
    faEye,
    faEyeSlash,
    faFileExcel,
    faFont,
    faGift,
    faGlobeAmericas,
    faGoogle,
    faHandPaper,
    faHistory,
    faImage,
    faInfoCircle,
    faKeyboard,
    faLanguage,
    faLaptop,
    faLevelUpAlt,
    faLightbulb,
    faList,
    faLock,
    faMapMarkerAlt,
    faMinus,
    faMinusSquare,
    faMobileAlt,
    faMoon,
    faMoonAuto,
    faPaperPlane,
    faPencilAlt,
    faPercent,
    faPlug,
    faPlus,
    faPlusCircle,
    faPlusSquare,
    faPowerOff,
    faQuestion,
    faQuestionCircle,
    faReply,
    faRocket,
    faSearch,
    faShareAlt,
    faSignOutAlt,
    faSort,
    faSortDown,
    faSortUp,
    faSpinner,
    faStar,
    faStream,
    faSun,
    faSync,
    faSyncAlt,
    faTimes,
    faTrashAlt,
    faUndoAlt,
    faUnlock,
    faUser,
    faUserCog,
    faWaveSquare,
);
